import { Component, OnInit, ViewContainerRef, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
// import { HeaderComponent } from '../common/header/header.component';
import { Router } from '@angular/router';
import { CruiseService } from '../services/cruise.service';
import { PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

// import { HttpClient, HttpEventType } from '@angular/common/http';
declare var jQuery: any;
declare var window: any;

@Component({
    selector: 'app-login',
    templateUrl: './adminlogin.component.html',
    styleUrls: []
})
export class AdminLoginComponent implements OnInit {

    public username: any;
    public password: any;
    public agent: any = {
        address: "",
        city: "",
        state: "",
        country: "",
        pincode: "",
        phone: "",
        agencyName: "",
        contactPerson: "",
        lastName: "",
        designation: "",
        mobile: "",
        password: "",
        gstNo: "",
        panNo: "",
        AvailableCredit: "",
        agencyType: "A"
    };
    public isAgentLoggedIn: any = false; private imageError: any = '';
    public portaltype: any = '';
    public email: any = '';
    public Bookingref: any = '';
    public ticketUrls: any = "";
    public filename: any = "";
    public trans: any = "";
    public GSTNdiv: any = '';
    public Callagentremarks: any = '';
    public Callagentemail: any = '';
    public Callmobile: any = '';
    private merchantsetup: any = {};
    private merchantsetups: any = {};
    fileData: File = null;
    previewUrl: any = null;
    fileUploadProgress: string = null;
    uploadedFilePath: string = null;

    public fileUrl: any;
    public file: File = null; private base64string: any = ''; private fileName: any = ''; private baseURL: any = ''; private fullURL: any = '';

    // Labels
    public logintxt: any = 'Agent Sign In'; public signuptxt: any = 'Agent Sign Up';

    constructor(@Inject(PLATFORM_ID) private platformId: Object,
        private loginService: CruiseService, private toastr: ToastrService, private vcr: ViewContainerRef,
        public router: Router, platformLocation: PlatformLocation) {
    }

    ngOnInit() {

    }

    login() {
        if (this.username && this.password)
            this.loginService.loginAgent(this.username, this.password, 'B2B').subscribe(
                data => {
                    //var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                    var orgData = JSON.parse(JSON.stringify(data)).d;
                    if (isPlatformBrowser(this.platformId)) sessionStorage.setItem("logindata", JSON.stringify(orgData));
                    var resp = JSON.parse(orgData);
                    if (resp.status == "success") {
                        if (isPlatformBrowser(this.platformId)) {
                            sessionStorage.setItem("isAgentLoggedIn", "true");
                            sessionStorage.setItem("loginType", "B2B");
                        }
                        jQuery("#agentloginSignup").modal("hide");
                        this.toastr.success("Login success...!");
                        if (this.fullURL.indexOf("home") > -1) {
                            window.location.reload();
                        }
                        else {
                            setTimeout(() => {
                                this.router.navigate(["/"]);
                            }, 500);
                        }
                    } else {
                        this.toastr.error(resp.status);
                    }
                },
                error => {
                    this.toastr.error("Unable to login...! Try again...!")
                }
            )
        else {
            this.toastr.warning("Please provide username or password...!")
        }
    }

    keyPress(event: any) {
        const pattern = /[0-9\ ]/;

        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    onlyAlphabets(e: any) {
        try {
            if (window.event) {
                var charCode = window.event.keyCode;
            }
            else if (e) {
                var charCode = e.which;
            }
            else { return true; }
            if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || (charCode == 32))
                return true;
            else
                return false;
        }
        catch (err) {
        }
    }

    register() {
        if (!this.agent.email) {
            this.toastr.warning("Please provide Correct Email...!");
            return false;
        } else {
            var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
            if (!emailReg.test(this.agent.email)) {
                this.toastr.warning("Please provide Correct Email...!");
                return false;
            }
        }
        if (!this.agent.agencyName) {
            this.toastr.warning("Please provide Name...!")
            return false;
        }
        if (!this.agent.contactPerson) {
            this.toastr.warning("Please provide First Name...!")
            return false;
        }
        if (!this.agent.lastName) {
            this.toastr.warning("Please provide Last Name...!")
            return false;
        }
        if (!this.agent.mobile) {
            this.toastr.warning("Please provide Mobile...!")
            return false;
        } else {
            var mobileReg = /^(\d{10})?$/;
            if (!mobileReg.test(this.agent.mobile)) {
                this.toastr.warning("Please provide Correct Mobile Number. 10 Digit...!");
                return false;
            }
        }
        if (!this.agent.password) {
            this.toastr.warning("Please provide Password...!")
            return false;
        }

        var agentcode = "";

        this.loginService.registerAgent(this.agent, agentcode, this.base64string, this.filename).subscribe(
            data => {
                var resp = JSON.parse(JSON.parse(JSON.stringify(data)).d);
                if (resp.status == "success") {
                    jQuery("#login-tab").click();
                    jQuery("#agentloginSignup").modal("hide");
                    this.toastr.success("Registration successful...! Please login...1")
                    setTimeout(() => {
                        this.router.navigate(["/"]);
                    }, 5000);
                }
                else { this.toastr.warning(resp.status) }
            }, error => {
                this.toastr.error("Unable to register...!")
            }
        )
    }

    forgetpassword() {
        if (!this.username) {
            this.toastr.warning("Please provide email...!")
            return false;
        }
        this.loginService.forgetPassword(this.username, 'B2B').subscribe(

            data => {
                jQuery("#login-tab").click();
                jQuery("#agentloginSignup").modal("hide");
                this.toastr.success("Password sent on registered email...!")
            }, error => {
                this.toastr.error("Email not registered, Please try with valid email...!")
            }
        )
    }
}